module.exports = __webpack_public_path__ + "img/icon_2.ca982025.png";